export default __webpack_public_path__ + "static/media/maybrown.e05d6e43.png";